export const ReparoRequestMethodHeader = 'Reparo-Request-Method';
export const ReparoVersionHeader = 'Reparo-Version';
//# sourceMappingURL=api.js.map